import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const createAndUpdateTrack = createAsyncThunk('track/createAndUpdateTrack', async ({ token, payload, trackId }) => {
    const response = await api.post(
        '/tracks/create',
        { payload, id: trackId, },
        {
            token: token,
        },
    );
    return response.data;
});

export const getArtists = createAsyncThunk('track/getArtists', async ({ token }) => {
    const response = await api.get(
        '/artists/all/ignore-Pagination',
        {
            token: token,
        },
    );
    return response.data.data;
});

export const getAllTracks = createAsyncThunk('track/getAllTracks', async ({ token, page = 1, limit = 13, search = "" }) => {
    const response = await api.get(
        '/tracks/basic',
        {
            token: token,
            params: {
                page,
                limit,
                search
            }
        },
    );
    return response.data.data;
});

export const getTrackById = createAsyncThunk('track/getTrackById', async ({ token, id }) => {
    const response = await api.get(
        `/tracks/${id}`,
        {
            token: token,
        },
    );
    return response.data.data;
});

export const deleteTrack = createAsyncThunk('track/deleteTrack', async ({ token, id }) => {
    const response = await api.delete(
        `/tracks/${id}`,
        {
            token: token,
        },
    );
    return response.data.data;
});

export const getRemixers = createAsyncThunk('track/getRemixers', async ({ token }) => {
    const response = await api.get(
        '/remixers/all/ignore-Pagination',
        {
            token: token,
        },
    );
    return response.data;
});

export const getTags = createAsyncThunk('coupon/getTags', async ({ token }) => {
    const response = await api.get(
        '/tags/all/ignore-Pagination',
        {
            token: token,
        },
    );
    return response.data;
});

export const checkDuplicateTracks = createAsyncThunk('track/checkDuplicateTracks', async ({ token, name }) => {
    const response = await api.get(
        `/tracks/check-duplicate/${name}`,
        {
            token: token,
        },
    );
    return response.data;
})

export const checkDetailedDuplicateTrack = createAsyncThunk(
    'track/checkDetailedDuplicateTrack',
    async ({ token, trackTitle, editTitles, artistNames }, thunkAPI) => {
        const response = await api.post(`/tracks/check/duplicate-detailed`,
            { trackTitle, editTitles, artistNames },
            {
                token: token,
            },
        );
        return response.data;
    }
);

export const refetchTrackFeatures = createAsyncThunk(
    'track/refetchTrackFeatures',
    async ({ trackTitle, artistName }) => {
        console.log('Refetching features for:', trackTitle, artistName);
        const response = await api.post('/tracks/refetch-features', {
            trackTitle,
            artistName
        });
        return response.data;
    }
);



export const fetchCharts = createAsyncThunk(
    "charts/fetchCharts",
    async ({ genre, period }) => {
        const response = await api.get(`/charts/get-charts-admin?genre=${genre}&period=${period}`);
        return response.data;
    }
);

export const fetchChartManipulations = createAsyncThunk(
    "charts/fetchChartManipulations",
    async ({ timespan, genre }) => {
        const genreParam = genre && genre !== "All Genres" ? `&genre=${encodeURIComponent(genre)}` : "";
        const response = await api.get(`/chart-manipulation/manipulations?timespan=${timespan}${genreParam}`);
        return response.data;
    }
);

export const addTrackToChart = createAsyncThunk(
    "charts/addTrackToChart",
    async ({ trackId, editId, rank, timespan, genre }) => {
        const payload = { trackId, editId, rank, timespan, genre: genre || null };
        const response = await api.post(`/chart-manipulation/add-track`, payload);
        return response.data;
    }
);

export const deleteTrackToChart = createAsyncThunk(
    "charts/deleteTrackToChart",
    async ({ manipulationId }) => {
        const response = await api.delete(`/chart-manipulation/${manipulationId}`);
        return response.data;
    }
);